<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// test comment
export default defineComponent({
  name: 'App',
});
</script>
